import { Component } from 'react';
import { Crisp } from 'crisp-sdk-web';

class CrispChat extends Component {
  componentDidMount() {
    Crisp.configure('5e8b0798-a5b0-4cde-9a2e-32bd482b5e57');
  }

  render() {
    return null;
  }
}
export default CrispChat;
